var _rect, _rect2, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 125,
    viewBox: "0 0 146 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.5715,
    y: 20.6901,
    width: 26.7996,
    height: 19.3274,
    rx: 2,
    transform: "rotate(-30.018 72.5715 20.6901)",
    fill: "#24C2F3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71.3574,
    y: 0.380554,
    width: 26.7996,
    height: 19.3274,
    rx: 2,
    transform: "rotate(52.5921 71.3574 0.380554)",
    fill: "#24C2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5273 65.7095C92.152 66.7484 92.6938 67.8841 93.7373 68.2463L120.847 77.6544L118.735 84.1688C117.568 87.7666 119.55 91.5944 123.161 92.7184L127.953 94.21C131.645 95.3589 135.603 93.3091 136.796 89.6316L139.144 82.389C139.23 82.2582 139.303 82.1154 139.358 81.9618L143.734 69.8473C144.109 68.8084 143.567 67.6726 142.524 67.3105L99.472 52.3696C98.4285 52.0075 97.2784 52.5561 96.9031 53.595L92.5273 65.7095Z",
    fill: "#24C2F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6057 74.7728C53.9647 75.8174 53.4053 76.9446 52.3562 77.2904L25.1031 86.2739L27.1131 92.8205C28.2231 96.436 26.1816 100.232 22.5533 101.3L17.7389 102.716C14.0301 103.808 10.1037 101.696 8.96898 98.0004L6.73434 90.722C6.64993 90.5899 6.57979 90.446 6.52673 90.2916L2.34066 78.1102C1.98169 77.0655 2.5411 75.9384 3.59015 75.5926L46.8702 61.3261C47.9192 60.9803 49.0607 61.5468 49.4196 62.5914L53.6057 74.7728Z",
    fill: "#24C2F3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.1909,
    cy: 61.8142,
    rx: 44.177,
    ry: 42.1062,
    fill: "#24C2F3"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.6091,
    cy: 48.1868,
    rx: 2.0708,
    ry: 2.76106,
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.6533,
    cy: 49.5674,
    rx: 2.0708,
    ry: 2.76106,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.0759,
    cy: 68.7168,
    rx: 6.21239,
    ry: 8.97345,
    fill: "#333232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.43 107.372C68.43 116.14 61.322 123.248 52.5538 123.248C43.7857 123.248 36.6777 116.14 36.6777 107.372C36.6777 98.6036 43.7857 91.4956 52.5538 91.4956C61.322 91.4956 68.43 98.6036 68.43 107.372ZM46.641 107.372C46.641 110.637 49.2882 113.285 52.5538 113.285C55.8194 113.285 58.4667 110.637 58.4667 107.372C58.4667 104.106 55.8194 101.459 52.5538 101.459C49.2882 101.459 46.641 104.106 46.641 107.372Z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.704 108.752C105.704 117.52 98.5961 124.628 89.828 124.628C81.0599 124.628 73.9519 117.52 73.9519 108.752C73.9519 99.9841 81.0599 92.8761 89.828 92.8761C98.5961 92.8761 105.704 99.9841 105.704 108.752ZM83.9151 108.752C83.9151 112.018 86.5624 114.665 89.828 114.665C93.0936 114.665 95.7409 112.018 95.7409 108.752C95.7409 105.487 93.0936 102.839 89.828 102.839C86.5624 102.839 83.9151 105.487 83.9151 108.752Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLevel1);
export default __webpack_public_path__ + "static/media/UserLevel1.3815b06c884529a60331a4783ad0d3a5.svg";
export { ForwardRef as ReactComponent };